import { legacyRedirect } from './-components';
import { createFileRoute } from '@tanstack/react-router';

// The message library moved out of the Journeys (Ember) bundle to the
// Hydra-native `/workspaces/:workspaceId/message-library`. Redirect the old
// `/journeys/message-library` path so existing links keep working.
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/message-library')({
  beforeLoad: legacyRedirect('/workspaces/:workspaceId/message-library'),
});
